// import { ApolloClient, ApolloLink, InMemoryCache, concat } from '@apollo/client';
// import { onError } from '@apollo/client/link/error';
// import { createUploadLink } from 'apollo-upload-client';

// const httpLink = createUploadLink({
//   uri: process.env.REACT_APP_BASE_URL || 'https://core-dev.payfi.ng/'
// });

// const authMiddleware = new ApolloLink((operation, forward) => {
//   // add the authorization to the headers
//   operation.setContext({
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem('token')}` || null
//     }
//   });

//   return forward(operation);
// });

// const logoutLink = onError(({ networkError, graphQLErrors }: any) => {
//   if (networkError && networkError.statusCode === 401) {
//     // TODO: Log the user out
//   }
//   return graphQLErrors;
// });

// const client = new ApolloClient({
//   cache: new InMemoryCache(),
//   // @ts-ignore
//   link: concat(authMiddleware, httpLink, logoutLink)
// });

// export default client;

import { split, ApolloClient, InMemoryCache } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';

const httpLink = createUploadLink({
  uri: `${process.env.REACT_APP_BASE_URL}/`
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: `${process.env.REACT_APP_WEB_SOCKET_URL}/` || 'ws://dev.payfi.ng/'
  })
);

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      platform: 'Web App'
    }
  };
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  authLink.concat(httpLink)
);

const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache()
});

export default client;
